import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

const HipoTable = ({ difficultyPriorityData = null }) => {
  const [data, setData] = useState([
    [
      'Fatality (Single)',
      'Tumpahan minyak 15-100 barrel',
      'Kerusakan asset 1.000.000 - 5.000.000 USD',
    ],
    [
      'Fatality (Multiple)',
      'Tumpahan minyak >100 barrel',
      'Kerusakan asset >5.000.000 USD',
    ],
  ]);

  const [tingkatKesulitan, setTingkatKesulitan] = useState([
    'Manusia',
    'Lingkungan',
    'Asset',
  ]);

  const [priority, setPriority] = useState(['Significant', 'Catastrophic']);

  function getCellColor(priority) {
    if (priority === 'Low') {
      return '#cbff70';
    } else if (priority === 'Medium') {
      return '#ffe069';
    } else if (priority === 'High') {
      return '#ff8080';
    } else {
      return 'white';
    }
  }

  return (
    <div>
      <TableContainer component={Paper} sx={{ marginBottom: '20px' }}>
        <Table>
          <TableHead sx={{ backgroundColor: '#ffff00' }}>
            <TableRow>
              <TableCell>
                <div style={{ display: 'flex' }}>
                  <span>Tingkat Keparahan Incident</span>
                </div>
              </TableCell>
              {tingkatKesulitan.map((p) => (
                <TableCell key={p}>{p}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {priority.map((t, index) => (
              <TableRow key={t}>
                <TableCell
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  {t}
                </TableCell>
                {data[index].map((d, i) => (
                  <TableCell key={i}>{d}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default HipoTable;
